import { useMemo } from 'react';

/**
 * Calculates min/max date based on parent project.
 * @param {Object} parentProject - parent project.
 * @returns {Object} object with min and max dates.
 */

const useMinMaxDate = parentProject => {
  const minMaxDate = useMemo(() => {
    if (!parentProject) {
      return {};
    }

    const mmd = {};

    if (parentProject.beginDate) {
      mmd.minDate = new Date(parentProject.beginDate).toISOString();
    }

    if (parentProject.expirationDate) {
      mmd.maxDate = new Date(parentProject.expirationDate).toISOString();
    }

    return mmd;
  }, [parentProject]);

  return minMaxDate;
};

export default useMinMaxDate;
